// extracted by mini-css-extract-plugin
export default {"fixedPage":"SpinnerPage_fixedPage__OQ-aR","logoutPage":"SpinnerPage_logoutPage__F-k9V"};